// extracted by mini-css-extract-plugin
export var base = "_5d-0";
export var updateBanner = "_5d-1";